module.exports = __webpack_public_path__ + "img/map.24599cdc.png";